module.exports = __webpack_public_path__ + "img/customer-banner-bg.c13d3736.png";